import axios from 'axios';
import jwtDecode from 'jwt-decode';
import $http from '@/http.js';

export const login = ({ commit, dispatch, state }, { username, password }) => {
  $http
    .post(`${state.api_url}auth/loginpos`, { username, password })
    .then(function(response) {
      const userData = response.data;
      let pdv =
        window.location.pathname.includes('/event/natal-luz') ||
        window.location.pathname.includes('totem')
          ? 31821
          : response.data.pdv;
      let pos =
        window.location.pathname.includes('/event/natal-luz') ||
        window.location.pathname.includes('totem')
          ? 4382
          : response.data.pos;
      commit('SET_EVENT_POS', pos);
      commit('SET_EVENT_PDV', pdv);
      commit('SET_LOGINPOS_DATA', userData);

      commit('SET_USER_TOKEN', userData.access_token);
      dispatch('setLogoutTimer', userData.expires_in);
      const now = new Date();
      const expirationDate = new Date(
        now.getTime() + userData.expires_in * 1000
      );
      localStorage.setItem('token', userData.access_token);
      localStorage.setItem('expirationDate', expirationDate);
    })
    .catch(function(err) {
      console.error('Failed loging in', err);
      throw err;
    });
};

export const setClientToken = async ({ commit, dispatch }, params) => {
  try {
    commit('SET_CLIENT_TOKEN', params.access_token);
    commit('SET_EXPIRES_IN', params.expires_in);
    if (params.access_token) await dispatch('getClientData');
  } catch (err) {
    console.error('Failed loging in', err);
    throw err;
  }
};

export const clientLogin = async ({ commit, dispatch }, params) => {
  dispatch('addLoading');
  try {
    const { data } = await $http.post('auth/loginsite', params);
    const userData = data;
    await dispatch('setClientToken', {
      access_token: userData.access_token,
      expires_in: userData.expires_in,
    });
    dispatch('sendPostMessage', {
      login: true,
      logout: false,
      access_token: userData.access_token,
      expires_in: userData.expires_in,
    });
    dispatch('subtractLoading');
    return userData;
  } catch (error) {
    dispatch('subtractLoading');
    if (error.response && error.response.status === 409) {
      await dispatch('resetPassword', {
        username: params.username,
        old_password: params.password,
        new_password: params.password,
      });
    }
    if (error.response && error.response.status === 401) {
      dispatch('openSnackbar', {
        message: 'Login inválido, por favor verifique suas credenciais',
      });
    } else {
      dispatch('openSnackbar', { message: 'Falha ao realizar Login' });
      console.error('Failed loging in', error);
      throw error;
    }
  }
};

export const resetPassword = async ({ dispatch }, userFormBody) => {
  try {
    await axios.post(
      `${process.env.VUE_APP_SERVER}auth/resetpassword`,
      userFormBody
    );
    await dispatch('clientLogin', {
      username: userFormBody.username,
      password: userFormBody.new_password,
    });
  } catch (error) {
    console.error('Failed to reset passsword: ', error);
    throw error;
  }
};

export const eraseClientToken = ({ commit }) => {
  commit('SET_CLIENT_TOKEN', null);
  window.localStorage.removeItem('clientToken');
  commit('SET_EXPIRES_IN', null);
  window.localStorage.removeItem('expiresIn');
};

export const getClientData = ({ getters, dispatch }) => {
  dispatch('addLoading');
  $http
    .get('clients/details')
    .then(function(response) {
      if (response.status === 200) {
        const userData = response.data;
        // const phone = userData.phone.substring(userData.phone.length - 8)

        const clientID = getters.clientToken
          ? jwtDecode(getters.clientToken).sub
          : null;
        const data = {
          clientID,
          name: userData.name,
          lastname: userData.lastname,
          country: userData.country || 'Brasil',
          document: userData.document,
          phone: userData.phone,
          // ddd: (userData.phone.length === 10 || userData.phone.length === 11) ? userData.phone.substring(0, 2) : '',
          // ddi: userData.country === 'Brasil' ? 55 : '',
          email: userData.email,
        };
        dispatch('setBuyerData', data); // comprador
        dispatch('setUserProps', {
          selectedDocument: data.document.length === 11 ? 'cpf' : 'cnpj',
          emailConfirmation: data.email,
          email: data.email,
          document: data.document,
          name: data.name + ' ' + data.lastname,
          phone: userData.phone,
          country: data.country || 'Brasil',
        });
        dispatch('setSignSteps', { logged: true, signForm: false, step: 0 });
        const eventState = {
          id: getters.eventID,
          buyerData: data,
        };
        dispatch('saveCheckoutState', eventState);
      } else {
        // Limpar
        dispatch('setBuyerData', {}); // comprador
        dispatch('clearUserProps', {}); // usuário logado
        dispatch('setSignSteps', { logged: false, signForm: true, step: 0 });
      }
      dispatch('subtractLoading');
    })
    .catch(function(err) {
      dispatch('subtractLoading');
      // Limpar
      dispatch('setBuyerData', {}); // comprador
      dispatch('clearUserProps', {}); // usuário logado
      dispatch('setSignSteps', { logged: false, signForm: true, step: 0 });
      console.error('Failed loging in', err);
      throw err;
    });
};

export const tryAutoLogin = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return;
  }

  const expirationDate = localStorage.getItem('expirationDate');
  const now = new Date();
  if (now <= expirationDate) {
    return;
  }
  return true;
};

export const logout = ({ commit }) => {
  commit('DESTROY_USER_TOKEN');
};

export const setLogoutTimer = ({ commit }, expirationTime) => {
  setTimeout(() => {
    commit('DESTROY_USER_TOKEN');
  }, expirationTime * 1000);
};

export const emailExists = async ({ dispatch }, email) => {
  dispatch('addLoading');
  try {
    const { data } = await $http.get(`/clients/email/available/${email}`);
    dispatch('subtractLoading');
    return data;
  } catch (error) {
    dispatch('subtractLoading');
    throw error;
  }
};

export const cpfExists = async ({ dispatch }, cpf) => {
  dispatch('addLoading');
  try {
    const { data } = await $http.get(`/clients/cpf/available/${cpf}`);
    dispatch('subtractLoading');
    return data;
  } catch (error) {
    dispatch('subtractLoading');
    throw error;
  }
};

export const setUserProps = ({ commit }, data) => {
  commit('SET_USER_PROPS', data);
};
export const setUserBilletProps = ({ commit }, data) => {
  commit('SET_USER_BILLET_PROPS', data);
};

export const clearUserProps = ({ commit }) => {
  commit('CLEAR_USER_PROPS');
};

export const setSignSteps = ({ commit }, data) => {
  commit('SET_SIGN_STEPS', data);
};

export const forgotPassword = async ({ commit }, email) => {
  try {
    const { data } = await $http.post('clients/password/recover', {
      email,
    });
    commit('OPEN_SNACKBAR', { message: data.message, color: '#32b15b' });
    commit('SET_SIGN_STEPS', { step: 2 });

    return data;
  } catch (error) {
    throw error;
  }
};

export const checkVerificationCode = async ({ commit }, { email, token }) => {
  try {
    const { data } = await $http.get(
      `clients/password/reset/token/${email}/${token}`
    );

    return data;
  } catch (error) {
    throw error;
  }
};

export const setNewPassword = async ({ commit, dispatch }, passData) => {
  try {
    const { data } = await $http.post('clients/password/reset/token', passData);

    dispatch('setClientToken', {
      access_token: data.access_token,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const getStoreConfigs = async ({ commit, dispatch }, host) => {
  try {
    const { data } = await $http.get(`store/configs`);
    commit('SET_STORE_CONFIGS', data.configs);
    commit('SET_STORE', data);

    return data;
  } catch (error) {
    throw error;
  }
};
